export const LOOKUP_TABLE = {
  breaches: {},
  cells: {
    node_type: {
      "1": "2D_OPEN_WATER",
      "2": "2D_GROUNDWATER",
      "3": "1D_NO_STORAGE",
      "5": "2D_BOUNDARIES",
      "6": "2D_GROUNDWATER_BOUNDARIES",
      "7": "1D_BOUNDARIES",
      "4:": "1D_STORAGE",
    },
  },
  channels: {
    calculation_type: {
      "100": "embedded",
      "101": "isolated",
      "102": "connected",
      "105": "double connected",
    },
  },
  culverts: {
    calculation_type: {
      "0": "embedded",
      "1": "isolated",
      "2": "connected",
      "100": "embedded",
      "101": "standalone",
      "102": "connected",
      "105": "double connected",
    },
    cross_section_shape: {
      "1": "rectangle",
      "2": "circle",
      "3": "egg",
      "5": "tabulated rectangle",
      "6": "tabulated trapezium",
    },
    friction_type: {
      "1": "chezy",
      "2": "manning",
    },
  },
  levees: {
    material: {
      "1": "sand",
      "2": "clay",
    },
  },
  manholes: {
    calculation_type: {
      "0": "embedded",
      "1": "isolated",
      "2": "connected",
    },
    shape: {
      "00": "square",
      "01": "round",
      "02": "rectangle",
    },
  },
  nodes: {
    node_type: {
      "1": "2D Surface water",
      "2": "2D Groundwater",
      "3": "1D Without storage",
      "4": "1D With storage",
      "5": "2D Surface water boundary",
      "6": "2D Groundwater boundary",
      "7": "1D Boundary",
    },
    calculation_type: {
      "-1": "Boundary",
      "0": "Embedded",
      "1": "Isolated",
      "2": "Connected",
      "3": "Broad crested",
      "4": "Short crested",
      "5": "Double connected",
      "100": "Embedded added node",
      "101": "Isolated added node",
      "102": "Connected added node",
      "105": "Double connected added node",
    },
    content_pk: {
      "0": "None",
    },
  },
  orifices: {
    crest_type: {
      "3": "broad crested",
      "4": "short crested",
    },
    friction_type: {
      "1": "chezy",
      "2": "manning",
    },
  },
  pipes: {
    calculation_type: {
      "0": "embedded",
      "1": "isolated",
      "2": "connected",
      "3": "broad crested",
      "4": "short crested",
    },
    cross_section_shape: {
      "1": "rectangle",
      "2": "circle",
      "3": "egg",
      "5": "tabulated rectangle",
      "6": "tabulated trapezium",
    },
    friction_type: {
      "1": "chezy",
      "2": "manning",
    },
    material: {
      "0": "concrete",
      "1": "pvc",
      "2": "gres",
      "3": "cast iron",
      "4": "brickwork",
      "5": "HPE",
      "6": "HDPE",
      "7": "plate iron",
      "8": "steel",
    },
    sewerage_type: {
      "0": "mixed",
      "1": "rain water",
      "2": "dry weather flow",
      "3": "transport",
      "4": "spillway",
      "5": "zinker",
      "6": "storage",
      "7": "storage tank",
    },
  },
  pumps: {
    type: {
      "1": "pump based on suction side",
      "2": "pump based on delivery side",
    },
  },
  weirs: {
    crest_type: {
      "3": "broad crested",
      "4": "short crested",
    },
    cross_section_shape: {
      "1": "rectangle",
      "2": "circle",
      "3": "egg",
      "5": "tabulated rectangle",
      "6": "tabulated trapezium",
    },
    friction_type: {
      "1": "chezy",
      "2": "manning",
    },
  },
} as const;

export const getAssetPropertiesDisplayValue = (
  assetModelType: string,
  property: string,
  value: string
) => {
  const LOOKUP_TABLE_ANY = LOOKUP_TABLE as any;
  return (
    LOOKUP_TABLE_ANY[assetModelType] &&
    LOOKUP_TABLE_ANY[assetModelType][property] &&
    LOOKUP_TABLE_ANY[assetModelType][property][value]
  );
};
